<div *ngIf="authService.loggedIn()">
    <nav class="navbar navbar-expand-lg bg-branded">
        <div class="container">
            <a class="navbar-brand p-0 me-2" href="/" aria-label="Bootstrap">
                <img [src]="environment.assetBase + '/assets/img/10-4-admin.png'" class="img-fluid" width="45"
                     height="45"></a>
            <button class="navbar-toggler" type="button" (click)="isNavbarCollapsed = !isNavbarCollapsed"
                    data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div [ngbCollapse]="isNavbarCollapsed" class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto" *ngIf="authService.loggedIn()">
                    <li class="nav-item">
                        <div ngbDropdown class="d-inline-block">
                            <a class="nav-link" i18n ngbDropdownToggle>Shipping System</a>
                            <div ngbDropdownMenu aria-labelledby="dropdown-shipments">
                                <a ngbDropdownItem class="nav-link" routerLink="/shipping-system" i18n>Shipping System</a>
                                <a ngbDropdownItem class="nav-link" routerLink="/shipping-system-search" i18n>Søg</a>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item" *ngIf="permissionsService?.permissions?.Admin">
                        <div ngbDropdown class="d-inline-block">
                            <a class="nav-link" id="dropdown-price-robot" ngbDropdownToggle>Robot</a>
                            <div ngbDropdownMenu aria-labelledby="dropdown-price-robot">
                                <a ngbDropdownItem routerLink="/price-robot/products">Products</a>
                                <a ngbDropdownItem routerLink="/price-robot/competitors">Competitors</a>
                                <a ngbDropdownItem routerLink="/price-robot/rules">Rules</a>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav ml-auto" *ngIf="authService.loggedIn()">
                    <li class="nav-item" *ngIf="permissionsService?.permissions?.Admin">
                        <div ngbDropdown class="d-inline-block">
                            <a class="nav-link" ngbDropdownToggle>Settings</a>
                            <div ngbDropdownMenu aria-labelledby="dropdown-price-robot">
                                <a ngbDropdownItem routerLink="/users">Users</a>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="javascript:0" (click)="logout()" i18n>Logout</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</div>
